import { Button, Input, Label } from '@massilia/ui'
import { useState } from 'react'

interface PersonalDataAccessFormProps {
  description: string
  errorMessage: null | string
  isSubmitting: boolean
  onSubmit: (credentials: { lastName: string }) => void
  submitLabel: string
  title: string
}

/**
 * Mur d'accès aux données personnelles : le nom de famille.
 *
 * Il sert les trois surfaces publiques — proposition, demande, confirmation de
 * réservation : mêmes gestes, mêmes règles, seuls les mots changent
 * (ACCES-PERSO-NOM).
 *
 * Le message d'erreur du nom est le même pour toutes les causes d'échec —
 * c'est aussi ce que renvoie le serveur. Le formulaire ne doit pas être plus
 * bavard que lui.
 */
export function PersonalDataAccessForm({
  description,
  errorMessage,
  isSubmitting,
  onSubmit,
  submitLabel,
  title,
}: PersonalDataAccessFormProps) {
  const [lastName, setLastName] = useState('')

  const canSubmit = lastName.trim().length > 0 && !isSubmitting

  return (
    <form
      className="mx-auto flex w-full max-w-lg flex-col gap-4 rounded-2xl border border-gray-light-200 p-4 md:p-6"
      onSubmit={(event) => {
        event.preventDefault()
        onSubmit({ lastName: lastName.trim() })
      }}
    >
      <div className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-gray-light-900">{title}</h1>
        <p className="text-sm text-gray-light-600">{description}</p>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor="access-last-name">Nom de famille</Label>
        <Input
          autoComplete="family-name"
          id="access-last-name"
          onChange={(event) => setLastName(event.target.value)}
          placeholder="Nom de famille"
          value={lastName}
        />
      </div>

      {errorMessage && (
        <p className="text-sm text-red-600" role="alert">
          {errorMessage}
        </p>
      )}

      <Button
        className="bg-brand-600 text-white hover:bg-brand-700"
        disabled={!canSubmit}
        type="submit"
      >
        {submitLabel}
      </Button>
    </form>
  )
}
